import { SignedPostPolicyDto } from '@gorgias-help-center/shared/contact-form/feature-upload-attachments/signed-post-policy-response.dto';
import axios from 'axios';

export type AttachmentData = {
  filename: string;
  size: number;
  mimetype: string;
};

export class CloudStorageService {
  static async getCloudStoragePolicy(attachmentData: AttachmentData) {
    return axios.post<SignedPostPolicyDto>('/api/attachments', attachmentData);
  }
}
